import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function PainPoints() {
  const points = ['¿Te cansaste de que los clientes te regateen el precio porque te ven como un "instalador básico" que cualquiera puede reemplazar?', '¿Sentís ese vacío legal o técnico cuando estás frente a un tablero de bombas que falló y no tenés idea de por dónde empezar a medir?', '¿Ves pasar los trabajos de mantenimiento industrial (los que realmente dejan plata) y se los llevan otros porque a vos "te falta la parte de comandos"?'];
  return <section className="py-8 md:py-14 px-4 bg-brand-section" data-id="element-156">
      <div className="max-w-3xl mx-auto" data-id="element-157">
        <p className="text-sm md:text-base text-brand-text mb-6 text-center font-medium leading-relaxed" data-id="element-158">
          El mercado está lleno de electricistas que solo tiran cables. Cuando
          un tablero de bombas falla o una industria se detiene, no buscan a
          alguien que "pruebe a ver qué pasa"...{' '}
          <span className="font-bold bg-brand-secondary px-1" data-id="element-159">
            buscan a un experto.
          </span>{' '}
          Sin dominio de Comandos y PLC, estás dejando pasar los trabajos que
          realmente dejan dinero.
        </p>

        <div className="bg-white border-t-4 border-brand-danger p-4 md:p-6 rounded-xl shadow-lg mb-6" data-id="element-160">
          <h2 className="text-lg md:text-2xl font-black text-center mb-5 text-brand-text leading-tight" data-id="element-161">
            ¿TE SUENA FAMILIAR ALGUNA DE ESTAS SITUACIONES?
          </h2>

          <div className="space-y-3" data-id="element-162">
            {points.map((point, index) => <div key={index} className="flex items-start bg-brand-bg p-3 rounded-lg border border-gray-200" data-id="element-163">
                <AlertTriangle className="w-4 h-4 md:w-5 md:h-5 text-brand-danger mr-2.5 shrink-0 mt-0.5" data-id="element-164" />
                <p className="text-xs md:text-sm text-brand-text font-semibold leading-snug" data-id="element-165">
                  {point}
                </p>
              </div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-166">
          <h3 className="text-sm md:text-base font-black text-brand-danger bg-red-100 inline-block px-4 py-2.5 rounded-lg border border-red-200 leading-snug" data-id="element-167">
            Si no das el salto a la automatización y la lógica industrial hoy,
            vas a seguir peleando por migajas mientras el mundo técnico te pasa
            por arriba.
          </h3>
        </div>
      </div>
    </section>;
}